import type { Dayjs } from 'dayjs';
import type { IRäkenskapsår } from 'src/types/nya/common';

import dayjs from 'dayjs';

// ----------------------------------------------------------------------

/** Datum ur appkontexten kan vara rena strängar från localStorage. */
export function toDayjs(värde: unknown): Dayjs | null {
  if (!värde) return null;
  const d = dayjs(värde as string);
  return d.isValid() ? d : null;
}

/** Räkenskapsåren i stigande ordning efter `förstaDag`. Rör inte inlistan. */
export function sorteraRäkenskapsår(räkenskapsår: IRäkenskapsår[]): IRäkenskapsår[] {
  return [...räkenskapsår].sort(
    (a, b) => (toDayjs(a.förstaDag)?.valueOf() ?? 0) - (toDayjs(b.förstaDag)?.valueOf() ?? 0)
  );
}

/**
 * Räkenskapsåret som ska vara förvalt för en organisation.
 *
 * Organisationens `räkenskapsår` kommer inte sorterad från API:t (JPA lagrar dem i ett
 * `Set`), så det går inte att lita på sista elementet — för vissa föreningar är det ett
 * år som ligger flera år tillbaka. Året som pågår nu är det enda rimliga förvalet;
 * annars det senast påbörjade, och som sista utväg det senast startande året.
 */
export function väljRäkenskapsår(
  räkenskapsår: IRäkenskapsår[] | undefined
): IRäkenskapsår | undefined {
  if (!räkenskapsår?.length) return undefined;

  const idag = dayjs();
  const sorterade = sorteraRäkenskapsår(räkenskapsår);

  const pågående = sorterade.find((år) => {
    const start = toDayjs(år.förstaDag);
    const slut = toDayjs(år.sistaDag);
    return !!start && !!slut && !idag.isBefore(start, 'day') && !idag.isAfter(slut, 'day');
  });
  if (pågående) return pågående;

  const påbörjade = sorterade.filter((år) => {
    const start = toDayjs(år.förstaDag);
    return !!start && !idag.isBefore(start, 'day');
  });

  return påbörjade.length ? påbörjade[påbörjade.length - 1] : sorterade[sorterade.length - 1];
}
